export default {
    'name': 'dot',
    'width': '12',
    'height': '12',
    'viewBox': '0 0 12 12',
    'data': '<circle cx=\'6\' cy=\'6\' r=\'2\' fill=\'#42A463\'/>'
}
